import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Card, Col, Row, Typography,
} from 'antd';
import {
  BankOutlined, EnvironmentOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import { TruckIcon } from '../../components';

const SummaryRow = styled(Row)`
  margin-bottom: 8px;
`;

const SummaryCard = styled(Card)`
  .ant-card-body {
    padding: 10px 12px;
  }
`;

const SummaryCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SummaryCardText = styled.div`
  min-width: 0;
`;

const SummaryCardIcon = styled.span`
  font-size: 20px;
  color: ${({ iconColor }) => iconColor};
  display: inline-flex;
  align-items: center;
`;

const SummaryTitle = styled(Typography.Text)`
  display: block;
  color: ${({ theme: currentTheme }) => currentTheme.color.darkgray1};
  font-size: 12px;
`;

const SummaryValue = styled(Typography.Text)`
  display: block;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme: currentTheme }) => currentTheme.color.primary};
`;

const LocationsSummary = ({ summary }) => {
  const { t } = useTranslation();

  return (
    <SummaryRow gutter={8}>
      <Col span={8}>
        <SummaryCard size="small">
          <SummaryCardContent>
            <SummaryCardText>
              <SummaryTitle>{t('LOCATIONS.SUMMARY.ASSETS_AT_LOCATIONS')}</SummaryTitle>
              <SummaryValue>{summary.assetsAtLocationsCount}</SummaryValue>
            </SummaryCardText>
            <SummaryCardIcon iconColor="#4ADE80">
              <TruckIcon style={{ fontSize: '20px' }} />
            </SummaryCardIcon>
          </SummaryCardContent>
        </SummaryCard>
      </Col>
      <Col span={8}>
        <SummaryCard size="small">
          <SummaryCardContent>
            <SummaryCardText>
              <SummaryTitle>{t('LOCATIONS.SUMMARY.LOCATIONS_WITH_ASSETS')}</SummaryTitle>
              <SummaryValue>{summary.locationsWithAssetsCount}</SummaryValue>
            </SummaryCardText>
            <SummaryCardIcon iconColor="#38BDF8">
              <BankOutlined />
            </SummaryCardIcon>
          </SummaryCardContent>
        </SummaryCard>
      </Col>
      <Col span={8}>
        <SummaryCard size="small">
          <SummaryCardContent>
            <SummaryCardText>
              <SummaryTitle>{t('LOCATIONS.SUMMARY.EMPTY_LOCATIONS')}</SummaryTitle>
              <SummaryValue>{summary.emptyLocationsCount}</SummaryValue>
            </SummaryCardText>
            <SummaryCardIcon iconColor="#FB923C">
              <EnvironmentOutlined />
            </SummaryCardIcon>
          </SummaryCardContent>
        </SummaryCard>
      </Col>
    </SummaryRow>
  );
};

LocationsSummary.propTypes = {
  summary: PropTypes.shape({
    assetsAtLocationsCount: PropTypes.number,
    locationsWithAssetsCount: PropTypes.number,
    emptyLocationsCount: PropTypes.number,
  }),
};

LocationsSummary.defaultProps = {
  summary: {
    assetsAtLocationsCount: 0,
    locationsWithAssetsCount: 0,
    emptyLocationsCount: 0,
  },
};

export default LocationsSummary;
